<div class="min-h-screen bg-bg-base pb-12">
    @if (expert) {
        <app-expert-profile-header [expert]="expert"></app-expert-profile-header>

        <div class="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="grid grid-cols-1 gap-8 pb-12 lg:grid-cols-3">
                <div class="space-y-8 lg:col-span-2">
                    <app-expert-profile-about [expert]="expert"></app-expert-profile-about>
                    <app-expert-profile-properties [expert]="expert"></app-expert-profile-properties>
                    <app-expert-profile-deals [expert]="expert"></app-expert-profile-deals>
                    <app-expert-profile-reviews [expert]="expert"></app-expert-profile-reviews>
                </div>

                <div class="space-y-6">
                    <app-expert-profile-contact [expert]="expert"></app-expert-profile-contact>
                </div>
            </div>
        </div>
    } @else if (isLoading) {
        <div class="flex min-h-[400px] flex-col items-center justify-center text-center">
            <span class="loader mb-4 h-10 w-10"></span>
            <p class="body">{{ 'experts.profile.loading' | translate }}</p>
        </div>
    } @else {
        <div class="flex min-h-[400px] flex-col items-center justify-center text-center">
            <div class="mb-4 flex h-14 w-14 items-center justify-center rounded-xl border border-danger/20 bg-danger-soft">
                <i class="fas fa-exclamation-triangle text-2xl text-danger"></i>
            </div>
            <p class="body">{{ 'experts.profile.notFound' | translate }}</p>
        </div>
    }
</div>
